// MODULES / TABS  --------
export const MODULE_TABS = {
  PERSONAL: 'personal',
  EMPLOYMENT: 'employment',
  PERFORMANCE: 'performance',
  JOURNALS: 'journals',
  HELLO: 'hello',
  HR: 'hr',
  SHIFTS: 'shifts',
  LEAVE: 'leave',
  UNAVAILABILITY: 'unavailability',
  AVAILABILITY: 'availability',
  NEWSFEED: 'newsfeed',
  HISTORY: 'history',
  DOCUMENTS: 'documents',
  PAYROLL: 'payroll',
  ONBOARDING: 'onboarding-form',
  RTW: 'right-to-work',
};

export const MODULE_TABS_ROUTES = {
  PROFILE: 'team-profile',
  PERSONAL: {
    VIEW: 'team-profile-personal-tab',
    EDIT: 'team-profile-personal-tab-edit',
  },
  EMPLOYMENT: {
    VIEW: 'team-profile-employment-tab',
    EDIT: 'team-profile-employment-tab-edit',
    EDIT_AGREED_HOURS: 'team-profile-employment-tab-edit-agreed-hour',
  },
  PERFORMANCE: {
    VIEW: 'team-profile-performance-tab',
  },
  JOURNALS: {
    VIEW: 'team-profile-journals-tab',
    EDIT: 'team-profile-journals-tab-edit',
  },
  PAYROLL: {
    VIEW: 'team-profile-payroll-tab',
    EDIT: 'team-profile-payroll-tab-edit',
  },
  HR: {
    SETTINGS: 'team-profile-settings-tab',
    VIEW: 'team-profile-hr-tab',
    FORM: 'team-profile-onboarding-form',
    EDIT: 'team-profile-hr-tab-edit',
    ADD: 'team-profile-hr-tab-add',
    ADD_EXISTING: 'team-profile-hr-tab-add-existing',
  },
  SHIFTS: {
    VIEW: 'team-profile-shifts-tab',
  },
  LEAVE: {
    LIST: 'team-profile-leave-tab',
    EDIT_RETRO: 'team-profile-leave-tab-edit-retro',
    EDIT: 'team-profile-leave-tab-edit',
    ADD: 'team-profile-leave-tab-edit-add',
  },
  UNAVAILABILITY: {
    VIEW: 'team-profile-unavailability-tab',
    EDIT: 'team-profile-unavailability-tab-edit',
    ADD: 'team-profile-unavailability-tab-add',
  },
  NEWSFEED: {
    VIEW: 'team-profile-newsfeed-tab',
  },
  HISTORY: {
    VIEW: 'team-profile-history-tab',
  },
};

export const MODULE_TABS_ROUTES_PATH = {
  HR: {
    SETTINGS: 'team-profile-settings-tab',
    VIEW: '/team/:teamId/hr',
    FORM: '/team/:teamId/onboarding-form',
    EDIT: '/team/:teamId/documents',
    ADD: '/team/add-eo',
    ADD_EXISTING: '/team/add-eo/:employeeId',
  },
};

export const MODULE_TABS_KEYS = {
  PERSONAL: 'PERSONAL',
  EMPLOYMENT: 'EMPLOYMENT',
  PERFORMANCE: 'PERFORMANCE',
  JOURNALS: 'JOURNALS',
  HELLO: 'HELLO',
  HR: 'HR',
  SHIFTS: 'SHIFTS',
  LEAVE: 'LEAVE',
  UNAVAILABILITY: 'UNAVAILABILITY',
  AVAILABILITY: 'AVAILABILITY',
  NEWSFEED: 'NEWSFEED',
  HISTORY: 'HISTORY',
  DOCUMENTS: 'DOCUMENTS',
  PAYROLL: 'PAYROLL',
  ONBOARDING: 'ONBOARDING-FORM',
};

export const MODULE_TABS_INDEXED = Object.keys(MODULE_TABS).reduce(
  (reduced, key) => {
    reduced[MODULE_TABS[key]] = key;
    return reduced;
  },
  {}
);

export const MODULE_TABS_PERMISSIONS = {
  HR: ['Can_Manage_Employees'],
  DOCUMENTS: ['Can_Manage_Employees'],
  PAYROLL: ['Can_Manage_Employees'],
  ONBOARDING: ['Can_Manage_Employees'],
  LEAVE: ['Can_Approve_Leave'],
};

export const MODULE_GROUP = {
  PROFILE: 'profile',
  SCHEDULING: 'scheduling',
  ACTIVITY: 'activity',
};

export const MODULE_GROUP_TABS = {
  [MODULE_GROUP.PROFILE]: [
    MODULE_TABS.PERSONAL,
    MODULE_TABS.EMPLOYMENT,
    MODULE_TABS.JOURNALS,
    MODULE_TABS.HELLO,
  ],
  [MODULE_GROUP.SCHEDULING]: [
    MODULE_TABS.SHIFTS,
    MODULE_TABS.LEAVE,
    MODULE_TABS.UNAVAILABILITY,
  ],
  [MODULE_GROUP.ACTIVITY]: [MODULE_TABS.NEWSFEED, MODULE_TABS.HISTORY],
};

export const MODULE_TABS_SUBTABS = {
  LEAVE: {
    FORM: {
      DETAILS: 'DETAILS',
      HISTORY: 'HISTORY',
    },
  },
  EMPLOYMENT: {
    PAYDETAILS: 'PAYDETAILS',
  },
};

export const MODULE_TABS_SUBTABS_ROUTES = {
  EMPLOYMENT: {
    PAYDETAILS: 'paydetails',
  },
};
// MODULES / TABS  --------

export const ROLES = {
  SYSTEM_ADMINISTRATOR: 1,
  SUPERVISOR: 3,
  EMPLOYEE: 50,
  LOCATION_MANAGER: 71,
};

export const INVITATION_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  DECLINED: 2,
  NOT_INVITED: 3,
};

export const ONBOARDING_STATUS = {
  // the below status is for employees who have never been onboarded using employee onboarding
  NOT_INITIATED: 1001,

  // Below are the expected statuses for onboarding
  TODO: 0,
  STARTED: 1,
  PROGRESS: 2,
  REVIEW: 3,
  SUBMITTED: 4,
  APPROVED: 5,
  PENDING_DETAILS: 6,
};

export const EMPLOYMENT_ROLES = {
  SYSTEM_ADMINISTRATOR: 1,
  SUPERVISOR: 3,
  EMPLOYEE: 50,
  LOCATION_MANAGER: 71,
  ADVISOR: 72,
};

export const INVITATION_STATUS_INDEX = Object.keys(INVITATION_STATUS).reduce(
  (reduced, state) => {
    reduced[INVITATION_STATUS[state]] = state;
    return reduced;
  },
  {}
);

export const ONBOARDING_STATUS_INDEX = Object.keys(ONBOARDING_STATUS).reduce(
  (reduced, state) => {
    reduced[ONBOARDING_STATUS[state]] = state;
    return reduced;
  },
  {}
);

// Same numbering as DeputecEmployee::GENDER_* on the PHP side.
export const GENDER_MALE_ID = 1;
export const GENDER_FEMALE_ID = 2;

export const GENDERS = [
  {
    id: 0,
    label: 'people:definitions:gender:not-say',
  },
  {
    id: GENDER_MALE_ID,
    label: 'people:definitions:gender:male',
  },
  {
    id: GENDER_FEMALE_ID,
    label: 'people:definitions:gender:female',
  },
  {
    id: 3,
    label: 'people:definitions:gender:non-binary',
  },
  // TODO: include non-binary with FF
];

export const PRONOUNS = [
  {
    id: 3,
    label: 'people:definitions:pronouns:they-them',
  },
  {
    id: 2,
    label: 'people:definitions:pronouns:she-her',
  },
  {
    id: 1,
    label: 'people:definitions:pronouns:he-him',
  },
  {
    id: 4,
    label: 'people:definitions:pronouns:custom',
  },
  {
    id: 0,
    label: 'people:definitions:pronouns:not-specified',
  },
];

export const PRONOUNS_CUSTOM_ID = 4;
export const PRONOUNS_NOT_SPECIFIED_ID = 0;

export const JOURNAL_CATEGORY_ENUM = { POSITIVE: 1, NEGATIVE: 2 };

export const THIRD_PARTY_SYNC = {
  ASSETS: `${window.DP_ASSETS || ''}img/icons/import/`, // TODO: review this window.DP_ASSETS it breaks tests and could be empty in prod
  XR: {
    Prefix: 'XR',
    Key: 'Xero',
    Label: 'Xero',
    PayrollLabel: 'Xero Payroll',
    Image: 'xr.png',
    ContractId: -4,
  },
};

export const THIRD_PARTY_SYNC_INDEXED = {
  Xero: THIRD_PARTY_SYNC.XR,
};

export const AWARDS_TYPE_ENUM = {
  TEMPLATE_TERM: { Id: -6, Label: 'Library Rates' },

  HOURLY: { Id: -1, Label: 'Hourly' },
  HOURLY_FLAT_40_AND_TIMEHALF_OVERTIME: {
    Id: -2,
    Label: 'Hourly (1.5 x Overtime)',
    ContractPrefix: 'DP_OVT1',
  },
  SALARY: { Id: -3, Label: 'Salary', ContractPrefix: 'DP_SAL' },
  AREA_OF_WORK: {
    Id: -7,
    Label: 'Area of Work',
    ContractPrefix: 'DP_AREA',
  },

  CUSTOM_TERM: { Id: -5, Label: 'Custom Rates' },

  EXTERNAL: { Id: -4, Label: 'External Rates' },
};
export const ABP_TYPE_ENUM = {
  HOURLY: 'ABP_Hourly',
  HOURLY_FLAT_40_AND_TIMEHALF_OVERTIME: 'ABP_HourlyAndTimehalf',
  RATE_PER_DAY: 'ABP_RatesPerDay',
  LIBRARY: 'Area Rate',
  CUSTOM: 'ABP_Custom',
};

export const PAY_RULE_ENUM = {
  REMUNERATION_TYPE: {
    HOURLY: { Id: 1, Label: 'Hourly' },
    SALARY: { Id: 2, Label: 'Salary' },
    UNIT: { Id: 3, Label: 'Unit' },
    MULTIPLE: { Id: 10, Label: 'Multiple' },
  },
  REMUNERATION_BY: {
    BASE: { Id: 1, Label: 'Base' },
    SHIFT_LOADING: { Id: 2, Label: 'Shift Loading' },
    PERIOD_LOADING: { Id: 3, Label: 'Period Loading' },
  },
  MULTIPLIER_BASE_RATE: {
    SHIFT_BASE_RATE: { Id: -1, Label: 'Shift Base Rate' },
    EMP_BASE_RATE: { Id: -2, Label: 'Base Rate' },
  },
};

export const SCHEDULE_ID_ENUM = {
  Daily: { Id: 0, Label: '' },
  Weekday: { Id: 0, Label: '' },
  Saturday: { Id: 0, Label: '' },
  Sunday: { Id: 0, Label: '' },
  PublicHoliday: { Id: 0, Label: '' },
};

export const BULK_ACTIONS = {
  EDIT_WORKPLACE: 1,
  EDIT_ROLE: 2,
  EDIT_STRESS_PROFILE: 3,
  EDIT_TRAINING: 4,
  SYNC: 5,
  EDIT_RATE: 6,
  SEND_MESSAGE: 7,
  INVITE: 8,
  UPDATE_LEAVE_BALANCE: 9,
  ASSIGNE_LEAVE_RULE: 10,
  REINSTATE: 11,
  DISCARD: 12,
  SET_STANDARD_HOURS: 13,
  EDIT_AGREED_HOURS: 14,
  REQUEST_RIGHT_TO_WORK: 15,
  MANAGE_LEAVE_ENTITLEMENTS: 16,
  ASSIGN_BUSINESS_ENTITY: 17,
  ASSIGN_JOB_TITLE: 18,
  DELETE: 99,
};

export const BULK_ACTIONS_INDEX = Object.keys(BULK_ACTIONS).reduce(
  (reduced, key) => {
    reduced[BULK_ACTIONS[key]] = key;
    return reduced;
  },
  {}
);

export const LEAVE_OVERLAPPING = {
  NO_ACTION: 0,
  MAKE_EMPTY: 1,
  MAKE_OPEN: 2,
};

// FLOWS
// NEW (create) -> APPROVED
// AWAITING (approve) -> APPROVED
// AWAITING (decline) -> DECLINED
// DATE_APPROVED (decline) -> DECLINED
// DATE_APPROVED (approve) -> APPROVED
// DECLINED (unarchive) -> AWAITING
// APPROVED (unapprove) -> DATE_APPROVED
// APPROVED (unapprove) -> DATE_APPROVED (decline) -> DECLINED
export const LEAVE_STATUS = {
  AWAITING: 0, // amber // Awaiting
  APPROVED: 1, // green // Approved
  DECLINED: 2, // red   // Declined
  CANCELLED: 3, // gray  // Cancelled
  DATE_APPROVED: 4, // amber // Date Approved
  PAY_APPROVED: 5, // green // Pay Approved
};

export const LEAVE_STATUS_INDEX = Object.keys(LEAVE_STATUS).reduce(
  (reduced, key) => {
    reduced[LEAVE_STATUS[key]] = key;
    return reduced;
  },
  {}
);

export const LEAVE_UNIT_TYPE = {
  HOURS: null,
  DAYS: 1,
};

export const LEAVE_UNIT_TYPE_INDEX = Object.keys(LEAVE_UNIT_TYPE).reduce(
  (reduced, key) => {
    reduced[LEAVE_UNIT_TYPE[key]] = key;
    return reduced;
  },
  {}
);

export const LEAVES = {
  SICK_LEAVE: 'dp_sick_leave',
  ANNUAL_LEAVE: 'dp_annual_leave',
  UNPAID_LEAVE: 'UNPAID',
};

export const DATE_FORMAT = {
  ROSTER: { LONG: 'l j F', SHORT: 'D jS M' },
  TIMESHEET: { LONG: 'l j F' },
};

// BREAK section
export const BREAK_TYPES = {
  REST: 'R',
  MEAL: 'M',
};

export const BREAK_TYPES_LONG = {
  REST: 'REST',
  MEAL: 'MEAL',
};

export const BREAK_STATES = {
  NOT_START: 0,
  IN_PROGRESS: 1,
  DONE: 2,
  SCHEDULED: 3,
  FINISHED_IGNORE_DURATION: 4,
};

export const BREAK_STATES_INDEX = Object.keys(BREAK_STATES).reduce(
  (reduced, state) => {
    reduced[BREAK_STATES[state]] = BREAK_STATES;
    return reduced;
  },
  {}
);

export const SHIFT_INFO_STATES = {
  IN_PROGRESS: 'In Progress',
  ROSTERED: 'Rostered',
  NOT_AVAILABLE: 'Not Available',
  LEAVE: 'On Leave',
  NONE: 'None', // no shifts available
  LATE: 'Late',
  ON_BREAK: 'BREAK',
};

// TODO: is this necessary?
// not started breaks
export const NOT_STARTED_BREAKS = [BREAK_TYPES.REST, BREAK_TYPES.MEAL];

// TODO: is this necessary?
// taken breaks
export const TAKEN_BREAKS = [
  BREAK_STATES.DONE,
  BREAK_STATES.FINISHED_IGNORE_DURATION,
];

// TODO: is this necessary?
// export const BREAK_IP_STRING = 'In Progress';

export const WORK_PERIOD_LEARN_MORE_URL =
  'https://help.deputy.com/hc/en-au/articles/4658212593423-Set-a-team-member-s-regular-working-hours';
export const PAY_RATE_LEARN_MORE_URL =
  'https://help.deputy.com/hc/en-au/articles/4755166437007-Enterprise-How-to-setup-pay-details-for-your-employees-in-the-people-tab';

export const WORK_PERIOD = {
  WEEKLY: {
    label: 'options:weekly',
    days: 7,
    weeks: 1,
  },
  TWO_WEEK: {
    label: 'options:2-weekly',
    days: 14,
    weeks: 2,
  },
  FOUR_WEEK: {
    label: 'options:4-weekly',
    days: 28,
    weeks: 4,
  },
};

// [CON-112 Navbar Event Tracking]
// The translations needed for screen details from the route path in the people-module-nav embed
export const NAVBAR_EVENT_SCREENS = {
  EXPORT: {
    screen: 'TIMESHEETS',
    name: 'Export timesheets',
  },
  APPROVE: {
    screen: 'TIMESHEETS',
    name: 'Approve Timesheets',
  },
  HOME: {
    screen: 'ME',
    name: 'Me',
  },
  NEWSFEED: {
    screen: 'NEWS_FEED',
    name: 'News Feed',
  },
  TEAM: {
    screen: 'PEOPLE',
    name: 'People',
  },
  REPORT: {
    screen: 'REPORTS',
    name: 'Reports',
  },
  ROSTER: {
    screen: 'SCHEDULE',
    name: 'Schedule',
  },
  TASKS: {
    screen: 'TASKS',
    name: 'Tasks',
  },
  LOCATIONS: {
    screen: 'LOCATIONS',
    name: 'Locations',
  },
};

export const helpDocs = {
  onboarding: {
    learnMoreUKOnboarding:
      'https://deputy.zendesk.com/hc/en-au/articles/4658069010703',
    learnMoreAUOnboarding:
      'https://help.deputy.com/hc/en-au/articles/4658046756751-Onboarding-new-employees-in-Australia-without-paperwork',
    learnMoreDocsignatureLink:
      'https://deputy.zendesk.com/hc/en-au/articles/4658059188751#h_38a89bcb56',
    learnMoreAboutEditTemplates:
      'https://help.deputy.com/hc/en-au/articles/6410128316431#h_01GSC5YT0CES6QK0110FBWMYCZ',
    learnMoreDocsignatureTemplateVideo:
      'https://www.youtube.com/watch?v=UGo_Y7GBkzA',
    priceUpdateAU: 'https://deputy.zendesk.com/hc/en-au/articles/4755498922895',
    learnMoreCustomQuestions:
      'https://help.deputy.com/hc/en-au/articles/4658059188751#h_01G6H87F7QMQBCCG0CQV1WJQJZ',
    viewTheTeamMemberExperienceUK:
      'https://help.deputy.com/hc/en-au/articles/4757840889999-Complete-your-paperless-onboarding-form-UK-#h_ec5e02d124',
    viewTheTeamMemberExperienceAU:
      'https://help.deputy.com/hc/en-au/articles/4614783655311-Complete-your-paperless-onboarding-form-Australia-#h_64590a0574',
    seeHowNewHireOnboardingWorks:
      'https://www.youtube.com/watch?v=RwjcOlUbSEw&list=PLrjPahrVBXBfgtU6m5pZmjoCPsSydXHsE',
  },
  leave: {
    standardHours:
      'https://help.deputy.com/hc/en-au/articles/6403359693839-Setting-standard-hours-for-a-work-day-when-managing-leave-UK-only',
    policyBuilder: 'https://help.deputy.com/hc/en-au/articles/10635847678863',
  },
  performance: {
    learnMoreTeamPerformance:
      'https://help.deputy.com/hc/en-au/articles/15573813195151-Introduction-to-Performance-management',
  },
};

export const FILTER_OPTION = {
  NONE: 'none',
};

export const REGULAR_SCHEDULES_BEHAVIOURS = {
  AGREED_HOURS: 'AGREED_HOURS',
  FWW_REGULAR_BASELINE: 'FWW_REGULAR_BASELINE',
  FWW_MEDIAN_HOURS: 'FWW_MEDIAN_HOURS',
  VERSIONED_AGREED_HOURS: 'VERSIONED_AGREED_HOURS',
};

// Statuses of FWW-compliant regular schedules
export const REGULAR_SCHEDULES_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  FORCED: 'FORCED',
  UNKNOWN: 'UNKNOWN',
};

export const CONSENT_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  CANCELLED: 'CANCELLED',
};

export const REGULAR_SCHEDULE_STATUS_CATEGORY = {
  CURRENT: 'current',
  UPCOMING: 'upcoming',
  PENDING: 'pending',
};

export const CYCLE_MAP = {
  WEEKLY: 0,
  TWO_WEEK: 1,
  THREE_WEEK: 2,
  FOUR_WEEK: 3,
};

export const DAYS_LIST = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export const COUNTRY_CODE = {
  US: 'US',
  GB: 'GB',
  AU: 'AU',
};

export const CHANGES_REASONS = {
  UNDEFINED: 'UNDEFINED',
  REQUESTED_BY_EMPLOYEE: 'REQUESTED_BY_EMPLOYEE',
  BONA_FIDE: 'BONA_FIDE',
  OTHER: 'OTHER',
};

export const NEEDS_EMPLOYEE_APPROVAL = {
  NEVER: 'NEVER',
  ALWAYS: 'ALWAYS',
  CONDITIONAL: 'CONDITIONAL',
};

export const NEEDS_EMPLOYEE_APPROVAL_ENUM = {
  NEVER: 0,
  ALWAYS: 1,
  CONDITIONAL: 2,
};

export const MAX_EMPLOYEE_LIST = 100;

export const PayRuleValueFields = {
  HourlyRate: 'HourlyRate',
  UnitValue: 'UnitValue',
  MulValue: 'MultiplierValue',
};

export function getPayRuleValueFieldName(payRule) {
  if (payRule.IsMultiplier) {
    return PayRuleValueFields.MulValue;
  }
  if (payRule.UnitValue !== null) {
    return PayRuleValueFields.UnitValue;
  }
  return PayRuleValueFields.HourlyRate;
}

export const WEEK_LABELS = {
  WEEKLY: 'Weekly',
  TWO_WEEK: '2-weekly',
  FOUR_WEEK: '4-weekly',
};

export const STANDARD_DAY_CALCULATION_METHOD = {
  UNKNOWN_METHOD: 'UNKNOWN_METHOD',
  AGREED_HOURS: 'AGREED_HOURS',
  DEFAULT_SHIFT: 'DEFAULT_SHIFT',
  REFERENCE_PERIOD: 'REFERENCE_PERIOD',
  LOCATION_DEFAULT_SHIFT: 'LOCATION_DEFAULT_SHIFT',
  EMPLOYMENT_CONDITION: 'EMPLOYMENT_CONDITION',
  PER_EMPLOYEE_STANDARD_DAY: 'PER_EMPLOYEE_STANDARD_DAY',
};

export const FILTERS_ENUM = {
  ACTIVE: {
    value: 1,
    translationKey: 'filter-options:active-pay-details',
  },
  INACTIVE: {
    value: 0,
    translationKey: 'filter-options:archived-pay-details',
  },
};

export const LEVEL_ASSN_TYPE_MAPPING = {
  EVERYONE: 1,
  EVERYONE_EXCEPT: 2,
  CERTAIN_GROUP: 1,
  UNKNOWN: 0,
};

export const SELECT_LEAVE_ENTITLEMENTS_OPTION = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  REPLACE: 'REPLACE',
};

export const CHANNEL = {
  DIRECT: 'DIRECT',
  EMBED_XERO: 'EMBED_XERO',
};
export const MASKED_TEXT = '•••••••';

// Mirrors the LeaveRules::TYPE_* constants in
// Tenant/Domain/Leave/LeaveRules/Model/LeaveRules.php. These are leave rule
// types, not leave rule ids - ids are per-tenant auto-increment.
export const LEAVE_RULE_TYPE = {
  SICK: 1,
  ANNUAL: 2,
  LONG: 3,
  PARENTAL: 4,
  BEREAVEMENT: 5,
  CARERS: 6,
  UNPAID: 7,
  LIEU: 8,
  TRAINING: 9,
  SVC_LEAVE: 10,
  OTHER: 11,
  PHNW: 12,
};

export const PAYROLL_ACCRUED_LEAVE_TYPES = {
  ANNUAL_LEAVE: LEAVE_RULE_TYPE.ANNUAL,
  PERSONAL_LEAVE: LEAVE_RULE_TYPE.SICK,
  LONG_SERVICE_LEAVE: LEAVE_RULE_TYPE.LONG,
  TIME_OFF_IN_LIEU: LEAVE_RULE_TYPE.LIEU,
};

// Payroll resolves a leave rule to an accrual by matching its name as well as
// its type, so a rule typed as annual but named something else is not
// payroll-owned. Keywords are matched case-insensitively as substrings.
export const PAYROLL_ACCRUED_LEAVE_NAME_KEYWORDS = {
  [PAYROLL_ACCRUED_LEAVE_TYPES.ANNUAL_LEAVE]: ['annual'],
  [PAYROLL_ACCRUED_LEAVE_TYPES.PERSONAL_LEAVE]: ['sick', 'personal', 'carer'],
  [PAYROLL_ACCRUED_LEAVE_TYPES.LONG_SERVICE_LEAVE]: [
    'long service',
    'lsl',
    'long',
  ],
  [PAYROLL_ACCRUED_LEAVE_TYPES.TIME_OFF_IN_LIEU]: ['lieu', 'toil'],
};

export const PEOPLE_JOURNALS_TEAM_PERFORMANCE_UPSELL_BANNER_HIDE_KEY =
  'PEOPLE_JOURNALS_TEAM_PERFORMANCE_UPSELL_BANNER_HIDE_KEY';
export const PEOPLE_JOURNALS_TEAM_PERFORMANCE_PROMO_BANNER_HIDE_KEY =
  'PEOPLE_JOURNALS_TEAM_PERFORMANCE_PROMO_BANNER_HIDE_KEY';
